<template>
  <div class="placeholder">
    <div class="placeholder__error">
      <div class="placeholder__error-block">
        <div class="placeholder__error-icon-wrapp">
          <SvgAsset
            class="placeholder__error-icon"
            :content="embedErrorIconPath"
          />
        </div>
        <span class="placeholder__error-text">Произошла ошибка</span>
      </div>
      <BHLink
        class="placeholder__error-link"
        :href="link"
        target="_blank"
      >
        Посмотреть на сайте
      </BHLink>
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import embedErrorIconPath from '@/assets/images/svg/embed-error-icon.svg?raw';

  export default defineNuxtComponent({
    name: 'EmbedsPlaceholder',
    components: { SvgAsset },
    props: {
      link: {
        type: String as PropType<string>,
        required: true,
      },
    },
    computed: {
      embedErrorIconPath: () => embedErrorIconPath,
    },
  });
</script>

<style lang="scss">
  .placeholder {
    background: #fbfafa;
    border: 1px solid #f3f3f3;
    border-radius: 2px;
    width: 100%;
    height: 160px;
    font-family: $text-font--1;
    display: flex;
    align-items: center;
    justify-content: center;

    &__error-block {
      display: flex;
      align-items: center;
    }

    &__error-icon-wrapp {
      width: 18px;
      height: 18px;
      display: block;
      margin-right: 11px;
    }

    &__error-icon {
      :deep() {
        svg path {
          fill: #969698;
        }
      }
      display: block;
    }

    &__error-text {
      color: #969698;
      @include smallText;
    }

    &__error-link {
      @include smallText;
      color: #699bdc;
      position: relative;
      display: block;
      margin-left: 29px;
      width: fit-content;

      @include hover {
        color: #1e61b9;
        &::before {
          background: #1e61b9;
        }
      }

      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        background: #699bdc;
        left: 0;
        bottom: 0;
      }
    }
  }
</style>
